import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

export interface SnackbarData {
    message: string;
    closeButtonLabel?: string;
    panelClass?: string | string[];
}

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class CustomSnackbarComponent {

    sanitizedHtml: SafeHtml;
    closeButtonLabel: string;
    class: string;

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData | string,
        private sanitizer: DomSanitizer,
        private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>
    ) {
        this.closeButtonLabel = typeof data === 'string' ? '' : (data.closeButtonLabel || '');
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(typeof data === 'string' ? data : data.message);
        this.class = typeof data === 'string' ? '' : (typeof data.panelClass === 'object' ? data.panelClass.join(', ') : data.panelClass);
    }

    close(): void {
        this.snackBarRef.dismissWithAction();
    }
}
